import React, { ReactElement } from "react";
import { GetServerSideProps } from "next";
import { getPageProps } from "@services/initial-calls";

import ContactTop from "@components/antiviruschoice/contactTop";
import FormSection from "@components/antiviruschoice/formSection";
import Header from "@components/shared/header";
import colors from "@styles/variables/medicalsoftwarequotesVariables.module.scss";
import MedicalSoftwareLogo from "@components/medicalsoftwarequotes/logo";
import MedicalSoftwareWrapper from "@components/layouts/medicalsoftwareWrapper";

export default function NextAutoWarrantyHome(): ReactElement {
    return (
        <MedicalSoftwareWrapper>
            <Header
                slogan="the best medical software quotes"
                textColor={colors.offerCallNumber}
            >
                <MedicalSoftwareLogo />
            </Header>
            <div className={`max-w-7xl mx-auto block px-4vw lg:px-4`}>
                <div className="bg-white">
                    <ContactTop iconsFillColor="#FFE2CD" />
                </div>
                <FormSection iconsFillColor="#FFE2CD" />
            </div>
        </MedicalSoftwareWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Contact Us" });
};
